import { useAtom } from "jotai";
import { myHiddenPrivilegesAtom, myPrivilegesAtom, myRoleAtom } from "../../atoms/atoms";

const useRole = () => {
  const [myRole, setMyRole] = useAtom(myRoleAtom);
  const [myPrivileges, setMyPrivileges] = useAtom(myPrivilegesAtom);
  const [myHiddenPrivileges, setMyHiddenPrivileges] = useAtom(myHiddenPrivilegesAtom);

  return {
    myRole,
    setMyRole,
    myPrivileges,
    setMyPrivileges,
    myHiddenPrivileges,
    setMyHiddenPrivileges,
  };
};

export default useRole;
